import React, { useContext } from 'react';
import "./header.css";
import logo from "../../assets/imgs/navbar/logo_azul.png";
import gcp from "../../assets/imgs/navbar/gcp.png";
import { FaAngleUp, FaArrowLeftLong } from "react-icons/fa6";
import { useState, useEffect, useRef } from "react";
import { MenuContext } from "../../views/dashboard/admin/admin"; 
import DashDetalles from '../../views/detalles/detalles';
import DashVuelosOperados from '../../views/detalles/vuelos_operados';
import DashVuelosNoFacturados from '../../views/detalles/vuelos_no_facturados';
import DashVuelosFacturados from '../../views/detalles/vuelos_facturados';


function Header(props) {
	const handleMenuClick = useContext(MenuContext);
    const [statusWeek, setStatusWeek] = useState(false);
    const [statusYear, setStatusYear] = useState(false);
    const [detailsComponents, setDetailsComponents] = useState(false);
    const [txtStatusWeek, setTxtStatusWeek] = useState('');
    const [txtStatusYear, setTxtStatusYear] = useState('');
    const linkRef = useRef(null);
    const [params, setParams] = useState({ week: '', year: '' });
    const [detailSelected, setDetailSelected] = useState('');
    const [statusDetail, setStatusDetail] = useState(false);
    const [statusUpdate, setStatusUpdate] = useState(false);

    const selectWeek = () => {
        setStatusYear(false);
        setDetailsComponents(false);
        setStatusWeek(!statusWeek);
    }
    const chooseOptionWeek = (option) => {
        setStatusWeek(!statusWeek);
        setTxtStatusWeek(option);
    }
    const selectYear = () => {
        setStatusWeek(false);
        setDetailsComponents(false);
        setStatusYear(!statusYear);
    }
    const chooseOptionYear = (option) => {
        setStatusYear(!statusYear);
        setTxtStatusYear(option)
    }

    const selectDetail = (option) => {
        setStatusDetail(!statusDetail);
        setStatusWeek(false);
        setStatusYear(false);    
    }

    const showDetailsComponents = () => {
        setStatusYear(false);
        setStatusWeek(false);
        setDetailsComponents(!detailsComponents);
    }

    const chooseOptionDetail = (option) => {
    	setDetailSelected(option);
    	setStatusDetail(false);
    }

    const empezarBusqueda = () => {
    	const tbody = document.getElementById('main-data');
       	tbody.innerHTML = '';
    	if(props.page == "Detalles"){
    		if (txtStatusWeek && txtStatusYear && detailSelected) {
    		    let newURL = `/dashboard/admin/${props.r_url}?week=${txtStatusWeek}&year=${txtStatusYear}&detail=${detailSelected}`;
    		    window.history.replaceState(null, "", newURL);
    		    if(statusUpdate){
    		        setStatusUpdate(false);
    		    }else{
    		        setStatusUpdate(true)
    		    }
    		}	
    	}else{
    		if (txtStatusWeek && txtStatusYear) {
		        //linkRef.current.href = `/${props.r_url}?week=${txtStatusWeek}&year=${txtStatusYear}`;
		        let newURL = `/dashboard/admin/${props.r_url}?week=${txtStatusWeek}&year=${txtStatusYear}`;
		        window.history.replaceState(null, "", newURL);
		        if(statusUpdate){
		            setStatusUpdate(false);
		        }else{
		            setStatusUpdate(true)
		        }
    		}	
    	}
    };

    useEffect(() => {
        // Obtener la URL actual
        const searchParams = new URLSearchParams(window.location.search);

        // Obtener los parámetros de la URL
        const week = searchParams.get('week');
        const year = searchParams.get('year');
        const detail = searchParams.get('detail');

        // Actualizar el estado si los parámetros existen
        if (week) {
            setParams(prevParams => ({ ...prevParams, week }));
        }
        if (year) {
            setParams(prevParams => ({ ...prevParams, year }));
        } 
        if (detail) {
            setParams(prevParams => ({ ...prevParams, detail }));
        } 

        setTxtStatusWeek(week);
        setTxtStatusYear(year);
        setDetailSelected(detail);
        setStatusYear(false);
        setStatusWeek(false);
        setStatusDetail(false);
    }, []);
    
    return (
    	<React.StrictMode>
	        <div className="header-container">
	            <div className="header-images d-flex">
	                <div className="img-cont">
	                    <img className="amc-cargo-logo" src={logo} alt="logo amc" />
	                </div>
	                <div className="img-cont ms-4">
	                    <img className="gcp-logo" src={gcp} alt="gcp logo" />
	                </div>
	            </div>
	            <div className="header-form-container">
	                <form className="header-form">

	                    <div className="form-group-header">
	                        <label>Semana</label>
	                        <div className="select-menu">
	                            <div className="select-btn" onClick={selectWeek}>
	                                <span className="btn-txt-default">{ txtStatusWeek }</span>
	                                <i className={statusWeek ? "icon-down" : "icon-up"}><FaAngleUp /></i>
	                            </div>
	                            {statusWeek && (
	                                <ul className="select-options bg-gradient-blue">
	                                    {[...Array(52).keys()].map((index) => {
	                                        const value = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
	                                        return (
	                                            <li
	                                                key={`option${value}`}
	                                                className="option"
	                                                value={value}
	                                                onClick={() => chooseOptionWeek(value)}
	                                            >
	                                                {value}
	                                            </li>
	                                        );
	                                    })}
	                                </ul>
	                                
	                            )}
	                        </div>
	                    </div>

	                    <div className="form-group-header">
	                        <label>Año</label>
	                        <div className="select-menu">
	                            <div className="select-btn" onClick={selectYear}>
	                                <span className="btn-txt-default">{ txtStatusYear }</span>
	                                <i className={statusYear ? "icon-down" : "icon-up"}><FaAngleUp /></i>
	                            </div>
	                            {statusYear && (
	                                <ul className="select-options bg-gradient-blue">
	                                    {Array.from({ length: new Date().getFullYear() - 2023 + 1 }, (_, i) => 2023 + i).map((year) => (
	                                        <li key={year} className="option" onClick={() => chooseOptionYear(year.toString())}>
	                                            {year}
	                                        </li>
	                                    ))}
	                                </ul>
	                            )}
	                        </div>
	                    </div>

	                    {props.page === "Detalles" && (
	                       	<div className="form-group-header">
	                            <label>Detalle</label>
	                            <div className="select-menu">
	                                <div className="select-btn" onClick={selectDetail}>
	                                    <span className="btn-txt-default">{ detailSelected }</span>
	                                    <i className={statusDetail ? "icon-down" : "icon-up"}><FaAngleUp /></i>
	                                </div>
	                                {statusDetail && (
		                                <ul className="select-options bg-gradient-blue">
		                                    <li className="option" onClick={() => chooseOptionDetail('Estaciones')}>Estaciones</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('MEX Dom')}>MEX Dom</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('MEX Expo')}>MEX Expo</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('Variación en peso')}>Variación en peso</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('+24 hrs')}>+24 hrs</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('+60 min')}>+60 min</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('Fantasmas')}>Fantasmas</li>
		                                    <li className="option" onClick={() => chooseOptionDetail('Facturas Duplicadas')}>Facturas Duplicadas</li>
		                                </ul>
		                            )}
	                            </div>
	                        </div>
	                    )}

	                    <span className="btn-amc-blue header-btn-search d-flex align-elements-center justify-content-center p-1 c-pointer" onClick={empezarBusqueda}>
	                        Buscar
	                    </span>
	                    <div className="btn-amc-blue header-btn-search pt-1 d-md-none d-block c-pointer" onClick={() => handleMenuClick("MainDashboard")}><FaArrowLeftLong /> Dashboard</div>
	                    {localStorage.getItem('admin_permission') === '1' && (
	                        <div className="btn-amc-blue header-btn-search pt-1 d-md-none d-block c-pointer" onClick={() => handleMenuClick("Bienvenido")}> Administrador</div>
	                    )}
	                    
	                </form>
	                <div className="img-cont">
	                    <h5 className="">CFDI 4.0</h5>
	                </div>
	                <div className="header-form-container mt-2" onClick={() => handleMenuClick("MainDashboard")}>
		                <span className="btn-amc-blue header-btn-search pt-1 d-none d-md-block" type="button"><FaArrowLeftLong /> Dashboard</span>
		            </div>
		            {localStorage.getItem('admin_permission') === '1' && (
		            <div className="header-form-container mt-2 c-pointer me-2" onClick={() => handleMenuClick("Bienvenido")}>
		            	<span className="btn-amc-blue header-btn-search pt-1 d-none d-md-block">
                        	Administrador
                       	</span>
                    </div>
		            )}
		            
	            </div>
	        </div>
	        <div className="row mt-4 px-4">
	        	<div className="col-md-3 col-12 mb-md-0 mb-2" onClick={() => handleMenuClick("DashDetalles")}>
	        		<span className={`d-flex text-decoration-none justify-content-around w-100 ${ props.page =="Detalles"?'blue-pill-fill':'blue-pill'}`}>
	        			<div>
	        				<p className="fs-11 mt-2 mb-2">Detalles</p>
	        			</div>
	        		</span>
	        	</div>
	        	<div className="col-md-3 col-12 mb-md-0 mb-2" onClick={() => handleMenuClick("DashVuelosOperados")}>
	        		<span className={`d-flex text-decoration-none justify-content-around w-100 ${ props.page =="VuelosOperados"?'blue-pill-fill':'blue-pill'}`}>
	        			<div>
	        				<p className="fs-11 mt-2 mb-2">Detalle Vuelos Operados</p>
	        			</div>
	        		</span>
	        	</div>
	        	<div className="col-md-3 col-12 mb-md-0 mb-2" onClick={() => handleMenuClick("DashVuelosFacturados")}>
	        		<span className={`d-flex text-decoration-none justify-content-around w-100 ${ props.page =="VuelosFacturados"?'blue-pill-fill':'blue-pill'}`}>
	        			<div>
	        				<p className="fs-11 mt-2 mb-2">Detalle Vuelos Facturados</p>
	        			</div>
	        		</span>
	        	</div>
	        	<div className="col-md-3 col-12 mb-md-0 mb-2" onClick={() => handleMenuClick("DashVuelosNoFacturados")}>
	        		<span className={`d-flex text-decoration-none justify-content-around w-100 ${ props.page =="VuelosNoFacturados"?'blue-pill-fill':'blue-pill'}`}>
	        			<div>
	        				<p className="fs-11 mt-2 mb-2">Detalle Vuelos No Facturados</p>
	        			</div>
	        		</span>
	        	</div>
	        </div>
	        {props.selectedComponent === 'DashDetalles' && <DashDetalles />}
	        {props.selectedComponent === 'DashVuelosOperados' && <DashVuelosOperados />}
	        {props.selectedComponent === 'DashVuelosNoFacturados' && <DashVuelosNoFacturados />}
	        {props.selectedComponent === 'DashVuelosFacturados' && <DashVuelosFacturados />}
        </React.StrictMode>
    )
}

export default Header;